// extracted by mini-css-extract-plugin
export default {"main":"EjercicioSelector_main__uhWES"};